import { render } from "preact";
import "@fontsource/anton/latin-400.css";
import "@fontsource/chivo/latin-400.css";
import "@fontsource/chivo/latin-700.css";
import "@fontsource/jetbrains-mono/latin-400.css";
import "@fontsource/jetbrains-mono/latin-700.css";
import "@fontsource/dela-gothic-one/latin-400.css";
import "@fontsource/dela-gothic-one/japanese-400.css";
import "./styles/index.css";
import { App } from "./app";

render(<App />, document.getElementById("app")!);
